export default __webpack_public_path__ + "images/bnb_0222dd.svg";